import axios from 'axios';

import { AXIOS_DEFAULT_CONFIG, routes } from '../../constants';


export default async function me() {
  const { data } = await axios.get(routes.me, AXIOS_DEFAULT_CONFIG);
  return data;
}
